import dayjs from 'dayjs'
import React, { useState } from 'react'
import Modal from 'react-modal'

import { Button, DatePicker } from 'Components'
import HeaderSmallModal from 'Components/HeaderSmallModal/HeaderSmallModal'
import { MealCategory } from 'Models'
import { registrationDateSelector } from 'ReduxStore/coreBackendUser'
import { useAppDispatch, useAppSelector } from 'ReduxStore/hooks'
import { journalDateSelector, setJournalDateAction } from 'ReduxStore/journalDay'
import { modalZIndexPriority } from 'Utils/zIndexPriority'

type Props = {
  isOpen: boolean
  displayedMealCategory?: MealCategory
  title: string | undefined
  onChange?: (value: MealCategory) => void
  onMove: (date: Date) => void
  onReset: () => void
}

const MoveJournalRecordModal: React.FC<Props> = ({ children, isOpen, title, onMove, onReset }) => {
  const dispatch = useAppDispatch()
  const currentJournalDate = useAppSelector(journalDateSelector).date
  const registrationDate = useAppSelector(registrationDateSelector)
  const dayFollowingCurrentJournalDate: Date = dayjs(currentJournalDate).add(1, 'day').toDate()
  const [displayedDay, setDisplayedDay] = useState<Date>(dayFollowingCurrentJournalDate)

  const move = (): void => {
    onMove(displayedDay)
    if (!dayjs(currentJournalDate).isSame(displayedDay, 'day')) {
      dispatch(setJournalDateAction(displayedDay))
    }
    resetAll()
  }

  const resetAll = (): void => {
    onReset()
    setDisplayedDay(dayFollowingCurrentJournalDate)
  }

  const onChangeDate = (date: Date | null): void => {
    if (date) {
      setDisplayedDay(date)
    }
  }

  return (
    <Modal style={modalZIndexPriority} isOpen={isOpen} onRequestClose={resetAll} ariaHideApp={false}>
      <div className="modal is-small bg-white p-0" style={{ overflow: 'visible' }}>
        <HeaderSmallModal onClose={resetAll}>
          <h2>Verschieben: {title}</h2>
        </HeaderSmallModal>

        <div className="row px-3 pt-2">
          <div className="col-12 col-sm-6 ">
            <DatePicker
              label={'Verschiebe zu'}
              value={displayedDay}
              onChange={onChangeDate}
              range={{ from: registrationDate }}
            />
          </div>

          <div className="col-12 col-sm-6">{children}</div>
        </div>

        <div className="row px-3 pb-3">
          <div className="col-12 col-sm-6">
            <Button type="button" theme="secondary" onClick={resetAll}>
              Abbrechen
            </Button>
          </div>

          <div className="col-12 col-sm-6">
            <Button disabled={false} onClick={move}>
              Verschieben
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default MoveJournalRecordModal
